import {
  Component,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { ILocation } from "../models/iLocation";

@Component({
  selector: "rc-address-card-list",
  templateUrl: "./address-card-list.component.html",
  styleUrls: ["./address-card-list.component.scss"]
})
export class AddressCardListComponent {
  @Input()
  locations: ILocation[] = [];
  @Input()
  selectedLocationTitle = "";
  @Input() isAccountingDisabled = false;
  @Output()
  editClickEmitter: EventEmitter<ILocation> = new EventEmitter();
  @Output()
  deleteClickEmitter: EventEmitter<ILocation> = new EventEmitter();

  editClickHandler(event) {
    this.editClickEmitter.emit(event);
  }

  deleteClickHandler(event) {
    this.deleteClickEmitter.emit(event);
  }

  getLocations() {
    return this.locations.sort((loc1, loc2) =>
      loc1.Title.localeCompare(loc2.Title.valueOf())
    );
  }
}
